import { render } from "./AboutQuantumHRWorkflowAssistant.vue?vue&type=template&id=26fa4b0f"
import script from "./AboutQuantumHRWorkflowAssistant.vue?vue&type=script&lang=js"
export * from "./AboutQuantumHRWorkflowAssistant.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__